import type { HomeTabKey } from '@hopdrive/feature-portal-home';

/** The nav entry points here so it stays lit on every tab. */
export const HOME_ROOT = '/home';

const TAB_SEGMENT: Record<HomeTabKey, string> = { now: '', team: 'team' };

export function homeTabPath(key: HomeTabKey): string {
  const segment = TAB_SEGMENT[key];
  return segment ? `${HOME_ROOT}/${segment}` : HOME_ROOT;
}

/** Anything unrecognized, including a path outside Home, reads as Now. */
export function resolveHomeTabKey(pathname: string): HomeTabKey {
  const trimmed = pathname.replace(/\/+$/, '');
  for (const key of Object.keys(TAB_SEGMENT) as HomeTabKey[]) {
    if (TAB_SEGMENT[key] && trimmed === homeTabPath(key)) return key;
  }
  return 'now';
}
